<template>
    <div class="cusModal" v-if="showtable">
        <div class="cusModalCont">
            <div class="cusModalTitle backBlack">
                {{ lang.chose_technical_or_more }}
            </div>
            <div class="cusModalBody">
                <v-row style="margin:10px;">
                    <v-col cols="12" md="4" v-for="(item, index) in users" :key="index">
                        <b-form-checkbox
                            :id="`checkbox_${index}`"
                            :ref="`item_${item.value}`"
                            class="tech-check"
                            @change="addToTech(item.value, index)"
                            :checked="isChecked(item.value)"
                        >
                            <span style="margin:2px;">{{item.text}}</span>
                            <div class="tech-load" v-if="item.workload">
                                <span>{{ lang.active || 'Active' }}: {{ item.workload.active_tasks || 0 }}</span>
                                <span>{{ lang.current_load || 'Current' }}: {{ formatHours(item.workload.remaining_hours) }}</span>
                                <span v-if="estimatedHours > 0">{{ lang.projected_load || 'With This' }}: {{ formatHours(projectedHours(item)) }}</span>
                                <span v-if="estimatedHours > 0">{{ lang.estimated_finish || 'Finish' }}: {{ projectedFinish(item) }}</span>
                            </div>
                        </b-form-checkbox>
                    </v-col>
                    <v-col cols="12" style="text-align:inline-end">
                        <b-button style="background:green;" @click="closeModal()">حقظ واغلاق</b-button>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default{
    data() {
        return {
            t_index: 0,
            showtable: false,
            title: '',
            tbrows: [],
            search: {
                sdate: '',
                edate: '',
            },
            source_id: 0,
            account_name: '',
            users: [],
            techs: [],
            type: 1,
            estimatedHours: 0
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    },
    methods: {
        isChecked(value) {
            return this.techs.map((item) => String(item)).includes(String(value));
        },
        formatHours(value) {
            const hours = Number(value || 0);
            if(!Number.isFinite(hours)) return '0 h';
            return `${Math.round(hours * 100) / 100} h`;
        },
        projectedHours(item) {
            const workload = item && item.workload ? item.workload : {};
            return Number(workload.remaining_hours || 0) + Number(this.estimatedHours || 0);
        },
        projectedFinish(item) {
            const hours = this.projectedHours(item);
            if(!Number.isFinite(hours) || hours <= 0) return '-';
            const finish = new Date(Date.now() + (hours * 60 * 60 * 1000));
            return finish.toLocaleString();
        },

        addToTech(value)
        {
            // const val = this.$refs[`item_${index}`];
            let index = this.techs.findIndex((item) => String(item) === String(value));
            if(index !== -1){
                this.techs.splice(index, 1)
            }else{
                this.techs.push(value)
            }
        },
        closeModal()
        {
            if(this.type == 1){
                this.$parent.$parent.newrow.workers_name = this.techs
            }else if(this.type == 2){
                this.$parent.$parent.tbrows[this.t_index].workers_name = this.techs
            }else if(this.type == 3){
                this.$parent.card.rows[this.t_index].empid = this.techs
            }else if(this.type == 4){
                this.$parent.newrow1.workers_name = this.techs
            }else if(this.type == 5){
                this.$parent.newrow.workers_name = this.techs
            }
            this.showtable = false;
            this.users = []
            this.techs = []
            this.t_index = 0
            this.estimatedHours = 0
        }
    },
    created() {
        //
    },
}
</script>
<style scoped>
.cusModal{
    position: fixed;
    background:#0000001a;
    top:0;
    left:0;
    bottom:0;
    right:0;
    z-index: 20000000;
    display:flex;
    justify-content: center;
    justify-items: center;
    align-items: center;;
}
.cusModalCont{
    position:relative;
    width:800px;
    height: 400px;
    border:1px solid #bbb;
    background:#fff;
    box-shadow: 0px 1px 1px 1px #0000001a;
    border-radius: 5px;
}
.cusModalClose{
    position: absolute;
    top:2px;
    left:10px;
    background:red;
    color:#fff;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
}
.cusModalCloseL:hover{
    background: darkred;
}
.cusModalTitle{
    padding:5px;
    text-align:center;
    border-color: #bbb !important;
    border-bottom-color: #000 !important;
}
.cusModalBody{
    overflow: auto;
    height:calc(70vh - 50px);
    max-height:calc(70vh - 50px);
    padding:5px;
}
.tech-check{
    padding:6px;
    border:1px solid #000;
    min-height:86px;
}
.tech-load{
    display:flex;
    flex-direction:column;
    gap:2px;
    margin-top:4px;
    color:#4b5563;
    font-size:11px;
    line-height:1.25;
}
.eportBtn{
    position: absolute;
    top:2px;
    left:60px;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
    display:flex;
    justify-content: space-between;
    justify-items: center;
    align-items: center;
}
.eportBtn div{
    padding:2px 5px;
    width:80px;
    font-size:.8rem;
    background:blue;
    margin-inline-start:5px;
    color:#fff;
    border-radius: 3px;
}
</style>

